import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const SET_USER_SETTINGS = gql`
  mutation SetUserSettings($formData: InUser!) {
    updateUser(data: $formData) {
      type,
      message
    }
  }
`;
